/**
 * AI视频创作平台 - 前端应用入口
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Antd from 'ant-design-vue';
import { DEFAULT_SEO } from '@shared/constants/brand';
import App from './App.vue';
import router from './router';

// 引入 CSD SDK 兼容层
import { initializeCSDSDK, setLoginRequiredCallback, getCSDClient } from './lib/csd-adapter';
import { useUserStore } from './stores/user';
import { useLoginModal } from './composables/useLoginModal';

// 引入全局样式
import './styles/index.scss';
// 引入 Ant Design Vue 样式
import 'ant-design-vue/dist/reset.css';

// 创建 Vue 应用实例
const app = createApp(App);

// 使用 Pinia 状态管理
const pinia = createPinia();
app.use(pinia);

// 使用 Vue Router 路由
app.use(router);

// 使用 Ant Design Vue 组件库
app.use(Antd);

// 初始化 CSD SDK（第三方账号体系）
initializeCSDSDK({
  baseURL: 'https://aivideo.api.360qnw.com',
  softId: 'mj123_web',
  storagePrefix: 'mxai_',
  version: '1.0.0.0',
  os: 1, // Web 端
  wxLoginUrl: 'https://appcloud.api.pcdashi.cn/api/wechat/oauth',
  wxLoginAndPayDomain: 'https://aivideo.api.360qnw.com',
}).catch((error) => {
  console.error('❌ CSD SDK 初始化失败:', error);
});

// 注册 CSD Token 过期回调：Token 失效时清除登录状态，弹出登录弹窗
setLoginRequiredCallback(() => {
  console.warn('[CSD] Token 已过期，清除登录状态');
  const userStore = useUserStore();
  userStore.logout();
  // 弹出登录弹窗引导用户重新登录
  const { goToLogin } = useLoginModal();
  goToLogin();
});

// 挂载应用
app.mount('#app');

const descriptionMeta = document.querySelector('meta[name="description"]');
if (descriptionMeta) {
  descriptionMeta.setAttribute('content', DEFAULT_SEO.description);
}

const keywordsMeta = document.querySelector('meta[name="keywords"]');
if (keywordsMeta) {
  keywordsMeta.setAttribute('content', DEFAULT_SEO.keywords);
}

// ============================================
// 微信授权回调处理
// 微信 H5 授权登录后，360qnw 会重定向回来并在 URL 中带上 token 参数
// ============================================
(async () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const wechatToken = urlParams.get('token');
    if (!wechatToken) {return;}

    console.log('[微信回调] 检测到 token 参数，开始自动登录');

    // 清除 URL 中的 token 参数（避免刷新重复登录）
    const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
    window.history.replaceState({}, '', cleanUrl);

    // 将 CSD token 存入 SDK（模拟登录成功状态）
    const csd = getCSDClient();
    if (!csd) {
      console.error('[微信回调] CSD SDK 未初始化');
      return;
    }

    // 设置 CSD token 到 AuthStore
    const authStore = csd.getAuthService().getAuthStore();
    authStore.setLoginInfo(wechatToken, null);

    // CSD token 已写入 SDK，直接拉取本地用户信息
    const userStore = useUserStore();
    await userStore.csdLogin();
    console.log('[微信回调] 自动登录成功');
  } catch (error) {
    console.error('[微信回调] 自动登录失败:', error);
  }
})();
